import { getFileExtension } from "./sender.fileAttachmentRules";

export type SenderAttachmentChipVisual = {
  iconBoxClassName: string;
  iconName: string;
  typeLabel: string;
};

export function getAttachmentDisplayName(filename: string): string {
  const dot = filename.lastIndexOf(".");
  if (dot <= 0) {
    return filename;
  }
  return filename.slice(0, dot);
}

export function getSenderAttachmentChipVisual(
  filename: string,
): SenderAttachmentChipVisual {
  const ext = getFileExtension(filename);

  switch (ext) {
    case "pdf":
      return {
        iconBoxClassName: "bg-content_accent2_primary",
        iconName: "file-pdf",
        typeLabel: "PDF",
      };
    case "docx":
      return {
        iconBoxClassName: "bg-content_aura_lv1_primary",
        iconName: "file",
        typeLabel: "DOCS",
      };
    case "xlsx":
      return {
        iconBoxClassName: "bg-content_aura_lv2_primary",
        iconName: "file-excel",
        typeLabel: "EXCEL",
      };
    case "csv":
      return {
        iconBoxClassName: "bg-content_aura_lv2_primary",
        iconName: "file-excel",
        typeLabel: "CSV",
      };
    case "txt":
      return {
        iconBoxClassName: "bg-content_brand_primary",
        iconName: "file-blank",
        typeLabel: "TXT",
      };
    case "jpg":
    case "jpeg":
    case "png":
    case "webp":
    case "gif":
    case "bmp":
    case "heic":
    case "heif":
    case "avif":
    case "svg":
      return {
        iconBoxClassName: "bg-content_accent5_primary",
        iconName: "landscape-solid",
        typeLabel: ext === "jpeg" ? "JPG" : ext.toUpperCase(),
      };
    default:
      return {
        iconBoxClassName: "bg-content_brand_primary",
        iconName: "file-blank",
        typeLabel: ext ? ext.toUpperCase() : "FILE",
      };
  }
}

export function getSenderAttachmentChipErrorVisual(
  filename: string,
): SenderAttachmentChipVisual {
  const ext = getFileExtension(filename);
  return {
    iconBoxClassName: "bg-content_accent2_tertiary",
    iconName: "error-circle-regular",
    typeLabel: ext ? ext.toUpperCase() : "FILE",
  };
}
